/* Developer API (group "Account"): API keys with scopes, spend caps and rate limits; the OpenAI-compatible
   and Anthropic-style chat API with quick-start snippets and an API explorer; usage and the redacted request
   log; the agent/task API and webhooks; search/answer/research prices; Sign in with Crosspoint AI + (OAuth
   clients, consent, allowance caps); embeds, SDKs and openapi.json; the document engine; handoff, share
   target, extension pairing and the remote-control relay. API: api/src/modules/devapi/README.md. */
import { lazy } from 'react';
import { Code2 } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'developer',
  title: 'Developer API',
  short: 'Developer',
  icon: Code2,
  group: 'Account',
  route: '/developer',
  order: 40,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['API-01', 'API-02', 'API-03', 'API-04', 'API-05', 'API-06', 'DEV-06', 'DEV-07'],
  commands: [
    { id: 'new-key', title: 'Create an API key', to: '/developer/keys?new=1', keywords: ['api', 'key', 'token', 'cx_live', 'openai', 'developer'] },
    { id: 'explorer', title: 'API explorer: send a test request', to: '/developer/explorer', keywords: ['console', 'curl', 'test', 'playground'] },
    { id: 'usage', title: 'API usage and request log', to: '/developer/usage', keywords: ['spend', 'logs', 'requests', 'rate limit'] },
    { id: 'oauth', title: 'Register a Sign in with Crosspoint AI + app', to: '/developer/signin?new=1', keywords: ['oauth', 'client', 'sso', 'login'] },
    { id: 'embed', title: 'Embed an assistant on a website', to: '/developer/embed?new=1', keywords: ['widget', 'script', 'chat bubble'] },
    { id: 'sdk', title: 'SDKs and OpenAPI', to: '/developer/embed', keywords: ['javascript', 'python', 'kotlin', 'openapi', 'swagger'] },
    { id: 'handoff', title: 'Handoff and share records', to: '/developer/devices', keywords: ['continue', 'device', 'share sheet', 'extension', 'pair'] },
  ],
});
